import axios from "axios";

import { useLazyViewer, useViewer } from "@/features/profile/hooks/useViewer";
import { workspaceRoutes } from "@/features/workspace/services/routes";
import { useNavigate } from "react-router";
import { useApolloClient } from "@apollo/client";
import { useLazyAccount } from "./useAccount";

export const useAccountSwitch = () => {
  const { fetchViewer } = useLazyViewer();
  const { handleFetchAccount } = useLazyAccount();
  const navigate = useNavigate();
  const apollo = useApolloClient();

  const handleSwitchAccount = async (accountId: number) => {
    localStorage.removeItem("recentOrg");

    try {
      await axios.post(
        workspaceRoutes.switchAccount,
        {
          account_id: accountId,
        },
        { withCredentials: true }
      );

      const viewerResult = await fetchViewer();
      handleFetchAccount(accountId);
      // Clear the apollo cache
      apollo.resetStore();

      const viewer = viewerResult.data?.viewer;

      navigate("/org");
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleSwitchAccount,
  };
};
